/**
 * Modulo de Usuarios -- primeiro dominio do accounts.
 *
 * Tudo que o modulo precisa vive nesta pasta: rotas, entity, service e pages.
 * Adicionar ou remover o modulo nao edita nenhum arquivo compartilhado: o
 * router e o menu coletam este arquivo por glob. Grupos, permissoes e empresas
 * entram do mesmo jeito, cada um na sua pasta.
 *
 * `nav` e o que aparece no menu lateral -- `section` decide em que pasta,
 * `montarMenu` (navigation/menuDosModulos.js) e quem monta a arvore. Aqui e
 * so "Resources": os modulos ficam direto na listagem, sem uma pasta
 * "Configuracoes" a mais para abrir.
 */
// Caminho relativo, e nao o alias `@/`: este arquivo e importado tambem pelo
// teste do menu, que roda em Node puro, onde o alias do Vite nao existe.
import { urlDoAdmin } from '../../services/sso.js';
export const nav = {
    permissao: 'accounts.users:ver',
    section: 'Resources',
    title: 'Users',
    icon: 'group',
    route: '/users',
    accordion: false,
};

export default [
    {
        path: '/users',
        name: '/users',
        component: () => import('./pages/UsersListPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.users:ver' },
    },
    {
        path: '/users/create',
        name: 'user-create',
        component: () => import('./pages/UserPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.users:ver' },
    },
    {
        // O aceite mudou para o admin, mas os links ja enviados por e-mail
        // apontam para ca. Sem isto, todo convite pendente cairia numa tela de
        // nao encontrado -- e o link do e-mail e justamente o que nao se pode
        // reemitir para quem ja o recebeu.
        path: '/invitation/:token',
        name: 'invitation',
        beforeEnter: (to) => {
            const destino = urlDoAdmin(`/invitation/${to.params.token}`);

            if (!destino) {
                // Sem URL do admin configurada nao ha para onde mandar; deixa
                // a navegacao seguir e cair no nao encontrado, que ao menos
                // diz alguma coisa.
                return true;
            }

            window.location.replace(destino);
            return false;
        },
        component: () => import('./pages/UsersListPage.vue'),
        meta: { publica: true, layout: 'blank' },
    },
    {
        // Lista dos convites enviados por esta empresa. Vive junto de usuarios
        // porque e do mesmo dominio: convidar e a forma de trazer alguem que
        // ja existe na plataforma.
        path: '/invitations',
        name: 'invitations',
        component: () => import('./pages/ConvitesListPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.users:ver' },
    },
    {
        path: '/users/edit/:id',
        name: 'user-edit',
        component: () => import('./pages/UserPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'accounts.users:editar' },
    },
];
